<template>
  <div>
    <v-row dense>
      <v-col cols="10">
        <h2 class="b-indicator__collapse-title">1. Значение показателя</h2>
        <h3 class="b-indicator__collapse-subtitle">Исходные данные:</h3>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="10">
        <p>
          <span class="font-weight-bold mb-1">Форма 5.03. (фрагмент)</span><br>
          Общая численность обучающихся по ... программам подготовки научных и научно-педагогических кадров в
          аспирантуре
          <br>
          по данным формы 1-НК, человек
        </p>
      </v-col>
    </v-row>
    <table>
      <thead>
      <tr>
        <th rowspan="3" colspan="3" class="text-left">Уровни образования</th>
        <th colspan="3" rowspan="2">Обучающихся (искл. квоту иностр.граждан)</th>
        <th colspan="6">Обучающихся - иностранных граждан</th>
        <th rowspan="4" class="border-right-zero" style="min-width: 66px;border-bottom: 0!important;"></th>
        <th rowspan="2" colspan="3">Всего обучающихся</th>
        <th rowspan="2" class="border-right-zero" colspan="3">Всего иностр.граждан</th>
      </tr>
      <tr>
        <th colspan="3">на усл.общего приема</th>
        <th colspan="3">обучающихся по квоте</th>
      </tr>
      <tr>
        <th>на 01.01.2022 г.</th>
        <th>на 01.01.2023 г.</th>
        <th>на 01.01.2024 г.</th>
        <th>на 01.01.2022 г.</th>
        <th>на 01.01.2023 г.</th>
        <th>на 01.01.2024 г.</th>
        <th>на 01.01.2022 г.</th>
        <th>на 01.01.2023 г.</th>
        <th>на 01.01.2024 г.</th>
        <th rowspan="2" style="border-bottom: 0">
          на 01.01.2022 г.<br/>
          <span class="font-weight-bold">гр.3 + гр.9</span>
        </th>
        <th rowspan="2" style="border-bottom: 0">

          на 01.01.2023 г.<br/>
          <span class="font-weight-bold">гр.4 + гр.10</span>
        </th>
        <th rowspan="2" style="border-bottom: 0">
          на 01.01.2024 г.<br/>
          <span class="font-weight-bold">гр.5 + гр.11</span>
        </th>
        <th rowspan="2" class="border-right-zero" style="border-bottom: 0">
          на 01.01.2022 г.<br/>
          <span class="font-weight-bold">гр.6 + гр.9</span>
        </th>
        <th rowspan="2" class="border-right-zero" style="border-bottom: 0">
          на 01.01.2023 г.<br/>
          <span class="font-weight-bold">гр.7 + гр.10</span>
        </th>
        <th rowspan="2" class="border-right-zero" style="border-bottom: 0">
          на 01.01.2024 г.<br/>
          <span class="font-weight-bold">гр.8 + гр.11</span>
        </th>

      </tr>
      <tr style="border-top: 1px solid #B7CED9">
        <th colspan="3" style="text-align: left"><span>1</span><span style="margin-left: 66px">2</span></th>
        <th v-for="(item) in 9" :key="item +Math.random()">{{ item + 2 }}</th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td colspan="3" style="text-align: left; min-width: 250px" class="kcp-name">
          Аспирантура (все формы обучения)
        </td>
        <td class="">{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nsaps20, 0, 'integer') }}</td>
        <td class="">{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nsaps21, 0, 'integer') }}</td>
        <td class="">{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nsaps22, 0, 'integer') }}</td>
        <td class="">{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nfaps20, 0, 'integer') }}</td>
        <td class="">{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nfaps21, 0, 'integer') }}</td>
        <td class="">{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nfaps22, 0, 'integer') }}</td>
        <td class="">{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nqaps20, 0, 'integer') }}</td>
        <td class="">{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nqaps21, 0, 'integer') }}</td>
        <td class="">{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.nqaps22, 0, 'integer') }}</td>
        <td class="border-bottom-zero"><img :src="require('@/assets/images/Vector_rigth_arrow.svg')"
                                            alt=""/></td>
        <td class="border-bottom-zero">{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.noaps20, 0, 'integer') }}</td>
        <td class="border-bottom-zero">{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.noaps21, 0, 'integer') }}</td>
        <td class="border-bottom-zero">{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.noaps22, 0, 'integer') }}</td>
        <td class="border-bottom-zero">{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.niaps20, 0, 'integer') }}</td>
        <td class="border-bottom-zero">{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.niaps21, 0, 'integer') }}</td>
        <td class="border-bottom-zero">{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.niaps22, 0, 'integer') }}</td>
      </tr>
      <tr>
        <td class="border-bottom-zero border-right-zero" v-for="(item) in 13" :key="item"></td>
        <td class="border-bottom-zero border-right-zero border-left-zero">
          <img class="ww-100" :src="require('@/assets/images/brackets/Скобка_general_value_bot.svg')" alt=""/>
        </td>
        <td class="border-bottom-zero border-right-zero border-left-zero">
          <img class="ww-100" :src="require('@/assets/images/brackets/Скобка_general_value_bot.svg')" alt=""/>
        </td>
        <td class="border-bottom-zero border-right-zero border-left-zero">
          <img class="ww-100" :src="require('@/assets/images/brackets/Скобка_general_value_bot.svg')" alt=""/>
        </td>
        <td class="border-bottom-zero border-right-zero border-left-zero">
          <img class="ww-100" :src="require('@/assets/images/brackets/Скобка_general_value_bot.svg')" alt=""/>
        </td>
        <td class="border-bottom-zero border-right-zero">
          <img class="ww-100" :src="require('@/assets/images/brackets/Скобка_general_value_bot.svg')" alt=""/>
        </td>
        <td class="border-bottom-zero border-right-zero">
          <img class="ww-100" :src="require('@/assets/images/brackets/Скобка_general_value_bot.svg')" alt=""/>
        </td>
      </tr>
      <tr>
        <td class="border-bottom-zero border-right-zero" v-for="(item) in 13" :key="item +Math.random()"></td>
        <td class="border-bottom-zero border-right-zero formul-text-table">
          <span class="d-flex flex-row justify-center align-end">АСП<span class="little-text font-size-extra-small__important" style="line-height:10px; ">2021</span></span>
        </td>
        <td class="border-bottom-zero border-right-zero formul-text-table">
          <span class="d-flex flex-row justify-center align-end">АСП<span class="little-text font-size-extra-small__important" style="line-height:10px; ">2022</span></span>
        </td>
        <td class="border-bottom-zero border-right-zero formul-text-table">
          <span class="d-flex flex-row justify-center align-end">АСП<span class="little-text font-size-extra-small__important" style="line-height:10px; ">2023</span></span>
        </td>
        <td class="border-bottom-zero border-right-zero formul-text-table">
          <span class="d-flex flex-row justify-center align-end">ИА<span class="little-text font-size-extra-small__important" style="line-height:10px; ">2021</span></span>
        </td>
        <td class="border-bottom-zero border-right-zero formul-text-table">
          <span class="d-flex flex-row justify-center align-end">ИА<span class="little-text font-size-extra-small__important" style="line-height:10px; ">2022</span></span>
        </td>
        <td class="border-bottom-zero border-right-zero formul-text-table">
          <span class="d-flex flex-row justify-center align-end">ИА<span class="little-text font-size-extra-small__important" style="line-height:10px; ">2023</span></span>
        </td>
      </tr>
      </tbody>
    </table>
    <h3 class="b-indicator__collapse-subtitle mt-5">Расчет значения показателя:</h3>
    <div class="d-flex flex-row align-center">
      <formulsFraction :need-bottom-line="true">
        <template>
          <div class="d-flex flex-row align-end">
            {{ item.title }}
            <div class="little-text ">0</div>
          </div>
        </template>
        <template #bottom>значение<br> показателя</template>
      </formulsFraction>
      <formulsFraction :need-bottom-line="false">
        <template>
          <span class="mt-8 alternate-text"> =</span>
        </template>
      </formulsFraction>
      <div class="d-flex alternate-text formul-text mb-5" style="line-height: 70px; font-size: 55px">
        (
      </div>
      <formulsFractionSimple>
        <template>
          <div class="d-flex flex-row align-end mr-1">
            ИА
            <div class="little-text ">2021</div>
          </div>
        </template>
        <template #bottom>
          <div style="  min-height: 49px">
            <div class="d-flex flex-row formul-text align-end mr-1">
              АСП
              <div class="little-text ">2021</div>
            </div>
          </div>
        </template>
      </formulsFractionSimple>
      <formulsFraction :need-bottom-line="false">
        <template>
          <span class="mt-8 alternate-text">+</span>
        </template>
      </formulsFraction>
      <formulsFractionSimple>
        <template>
          <div class="d-flex flex-row align-end mr-1">
            ИА
            <div class="little-text ">2022</div>
          </div>
        </template>
        <template #bottom>
          <div style="  min-height: 49px">
            <div class="d-flex flex-row formul-text align-end mr-1">
              АСП
              <div class="little-text ">2022</div>
            </div>
          </div>
        </template>
      </formulsFractionSimple>
      <formulsFraction :need-bottom-line="false">
        <template>
          <span class="mt-8 alternate-text">+</span>
        </template>
      </formulsFraction>
      <formulsFractionSimple>
        <template>
          <div class="d-flex flex-row align-end mr-1">
            ИА
            <div class="little-text ">2023</div>
          </div>
        </template>
        <template #bottom>
          <div style="  min-height: 49px">
            <div class="d-flex flex-row formul-text align-end mr-1">
              АСП
              <div class="little-text ">2023</div>
            </div>
          </div>
        </template>
      </formulsFractionSimple>
      <div class="d-flex align-center alternate-text mb-5" style="line-height: 70px; font-size: 55px">
        )
      </div>
      <formulsFraction :need-bottom-line="false">
        <template>
          <span class="mt-8 ml-1 alternate-text">× 100 ÷</span>
        </template>
      </formulsFraction>
      <formulsFraction :need-bottom-line="false" class="mr-1">
        <template>
          <span class="mt-8"> n </span>
        </template>
      </formulsFraction>
      <formulsFraction :need-bottom-line="false">
        <template>
          <span class="mt-8 alternate-text"> =</span>
        </template>
      </formulsFraction>
      <div class="d-flex align-center alternate-text mb-5" style="line-height: 70px; font-size: 55px">
        (
      </div>
      <formulsFractionSimple>
        <template>
          <div class="d-flex flex-row align-end mr-1">
            {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.niaps20, 0, 'integer') }}
          </div>
        </template>
        <template #bottom>
          <div style="  min-height: 49px">
            <div class="d-flex flex-row formul-text align-end mr-1">
              {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.noaps20, 0, 'integer') }}
            </div>
          </div>
        </template>
      </formulsFractionSimple>
      <formulsFraction :need-bottom-line="false">
        <template>
          <span class="mt-8 alternate-text">+</span>
        </template>
      </formulsFraction>
      <formulsFractionSimple>
        <template>
          <div class="d-flex flex-row align-end mr-1">
            {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.niaps21, 0, 'integer') }}
          </div>
        </template>
        <template #bottom>
          <div style="  min-height: 49px">
            <div class="d-flex flex-row formul-text align-end mr-1">
              {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.noaps21, 0, 'integer') }}
            </div>
          </div>
        </template>
      </formulsFractionSimple>
      <formulsFraction :need-bottom-line="false">
        <template>
          <span class="mt-8 alternate-text">+</span>
        </template>
      </formulsFraction>
      <formulsFractionSimple>
        <template>
          <div class="d-flex flex-row align-end mr-1">
            {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.niaps22, 0, 'integer') }}
          </div>
        </template>
        <template #bottom>
          <div style="  min-height: 49px">
            <div class="d-flex flex-row formul-text align-end mr-1">
              {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.noaps22, 0, 'integer') }}
            </div>
          </div>
        </template>
      </formulsFractionSimple>
      <div class="d-flex align-center alternate-text mb-5" style="line-height: 70px; font-size: 55px">
        )
      </div>
      <formulsFraction :need-bottom-line="false">
        <template>
          <span class="mt-8 ml-1 alternate-text"> × 100 ÷</span>
        </template>
      </formulsFraction>
      <formulsFraction :need-bottom-line="false" class="mr-1">
        <template>
          <span class="mt-8"> {{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data.noapsQ3, 0, 'integer') }}</span>
        </template>
      </formulsFraction>

      <formulsFraction :need-bottom-line="false">
        <template>
          <span class="mt-8 alternate-text"> =</span>
        </template>
      </formulsFraction>
      <formulsFraction :need-bottom-line="false">
        <template>
          <span class="mt-8">{{ $scripts.TableJs.checkValueWithNullAndReturnND(rowOfValues.data[item.dataFieldName+'b0'], item.prd+1, 'float') }}</span>
        </template>
      </formulsFraction>
    </div>
    <p>АСПk - общая численность обучающихся аспирантуры по данным k-го года</p>
    <p>ИАk - численность иностранных граждан, обучающихся в аспирантуре, по данным k-го года</p>
    <p >n - число лет, за которые имеются отчетные данные АСПk. Значение показателя А34 определяется за те годы, за которые имеются отчетные значения АСП, равные 10 или более.</p>
    <p class="mb-4" v-if="rowOfValues.data[item.dataFieldName+'nf22'] !== '0'">Если
    значение АСП за все годы отсутствует или менее 10, значение показателя А34 не рассчитывается, а его нормированная
      оценка определяется в соответствии с пунктом 7 Методики (по средним).</p>


  </div>
</template>

<script>
import formulsFraction from "@/components/cards/indicatiors/formulsFraction";
import formulsFractionSimple from "@/components/cards/indicatiors/formulsFractionSimple"

export default {
  name: "a34",
  components: {formulsFractionSimple, formulsFraction},
  props: {
    item: {
      type: Object
    },
    rowOfValues: {
      type: Object,
      default: () => {
      }
    },
  },
  methods: {},
}
</script>

<style lang="sass" scoped>

</style>